var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3083",
    "data-name": "Rectangle 3083",
    width: 24,
    height: 24,
    transform: "translate(-0.24)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dateIcon",
    transform: "translate(0.24)",
    opacity: 0.5,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0.284 0.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M5.985,5.714H23.031a2.557,2.557,0,0,1,2.557,2.557V23.613a2.557,2.557,0,0,1-2.557,2.557H5.985a2.557,2.557,0,0,1-2.557-2.557V8.271A2.557,2.557,0,0,1,5.985,5.714Z",
    transform: "translate(-3.429 -4.01)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M22.063,5.714H6.954a3.557,3.557,0,0,0-3.525,3.58v3.239h.852a1.833,1.833,0,0,1,1.7-1.7H23.031a1.833,1.833,0,0,1,1.7,1.7h.852V9.294A3.557,3.557,0,0,0,22.063,5.714Z",
    transform: "translate(-3.429 -4.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M21.985,16.147A1.279,1.279,0,1,1,20.707,14.9,1.279,1.279,0,0,1,21.985,16.147Z",
    transform: "translate(-7.496 -6.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M27.7,16.147A1.279,1.279,0,1,1,26.421,14.9,1.279,1.279,0,0,1,27.7,16.147Z",
    transform: "translate(-8.949 -6.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M21.985,21.861a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,21.985,21.861Z",
    transform: "translate(-7.496 -7.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M27.7,21.861a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,27.7,21.861Z",
    transform: "translate(-8.949 -7.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M10.557,21.861a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,10.557,21.861Z",
    transform: "translate(-4.591 -7.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M16.271,21.861a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,16.271,21.861Z",
    transform: "translate(-6.044 -7.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M10.557,27.575a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,10.557,27.575Z",
    transform: "translate(-4.591 -9.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M16.271,27.575a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,16.271,27.575Z",
    transform: "translate(-6.044 -9.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M21.985,27.575a1.279,1.279,0,1,1-1.278-1.248A1.279,1.279,0,0,1,21.985,27.575Z",
    transform: "translate(-7.496 -9.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M9.143,3.429v1.7",
    transform: "translate(-4.881 -3.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M27.429,3.429v1.7",
    transform: "translate(-9.53 -3.429)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.286
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.7226b73ab46ab87e8f5800611bb831a5.svg";
export { ForwardRef as ReactComponent };